import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';

const riskCategories = [
  {
    category: 'Pricing Risks',
    icon: 'DollarSign',
    color: '#FF4444',
    risks: [
      { id: 'r1', label: 'Property listed above suburb median by >15%', severity: 'high', flagged: true },
      { id: 'r2', label: 'Price reduced 2+ times in current campaign', severity: 'medium', flagged: false },
      { id: 'r3', label: 'Days on market exceeds suburb average (47 vs 32 days)', severity: 'medium', flagged: true },
    ]
  },
  {
    category: 'Structural & Building',
    icon: 'Home',
    color: '#FFAA00',
    risks: [
      { id: 'r4', label: 'No recent building inspection report available', severity: 'high', flagged: true },
      { id: 'r5', label: 'Property age >40 years — potential asbestos risk', severity: 'medium', flagged: false },
      { id: 'r6', label: 'Visible cracks or subsidence signs in photos', severity: 'high', flagged: false },
      { id: 'r7', label: 'Older electrical wiring (pre-2000)', severity: 'medium', flagged: true },
    ]
  },
  {
    category: 'Location & Environment',
    icon: 'MapPin',
    color: '#AA88FF',
    risks: [
      { id: 'r8', label: 'Located on arterial road — noise and resale impact', severity: 'medium', flagged: true },
      { id: 'r9', label: 'Flood zone or bushfire risk area', severity: 'high', flagged: false },
      { id: 'r10', label: 'Proximity to industrial or commercial zoning', severity: 'low', flagged: false },
    ]
  },
  {
    category: 'Legal & Title',
    icon: 'FileText',
    color: '#00D4FF',
    risks: [
      { id: 'r11', label: 'Easements or encumbrances on title', severity: 'medium', flagged: false },
      { id: 'r12', label: 'Pending council orders or notices', severity: 'high', flagged: false },
      { id: 'r13', label: 'Unapproved structures or extensions', severity: 'medium', flagged: false },
    ]
  },
];

const severityConfig = {
  high: { label: 'High', color: '#FF4444', bg: 'rgba(255,68,68,0.1)' },
  medium: { label: 'Medium', color: '#FFAA00', bg: 'rgba(255,170,0,0.1)' },
  low: { label: 'Low', color: '#00FF88', bg: 'rgba(0,255,136,0.1)' },
};

const RiskChecklist = () => {
  const [expanded, setExpanded] = useState(['Pricing Risks']);
  const toggle = (cat) => setExpanded(prev => prev?.includes(cat) ? prev?.filter(c => c !== cat) : [...prev, cat]);

  return (
    <div className="space-y-4">
      {riskCategories?.map((cat) => {
        const flaggedCount = cat?.risks?.filter(r => r?.flagged)?.length;
        const isOpen = expanded?.includes(cat?.category);
        return (
          <div key={cat?.category} className="bg-card rounded-xl border border-border overflow-hidden">
            <button onClick={() => toggle(cat?.category)} className="w-full flex items-center justify-between p-4 md:p-5 hover:bg-muted/30 transition-colors">
              <div className="flex items-center gap-3">
                <div className="w-9 h-9 rounded-lg flex items-center justify-center" style={{ background: `${cat?.color}20` }}>
                  <Icon name={cat?.icon} size={18} color={cat?.color} />
                </div>
                <span className="font-semibold text-foreground">{cat?.category}</span>
                {flaggedCount > 0 && (
                  <span className="px-2 py-0.5 rounded-full text-xs font-medium" style={{ background: 'rgba(255,68,68,0.15)', color: '#FF6666' }}>{flaggedCount} flagged</span>
                )}
              </div>
              <Icon name={isOpen ? 'ChevronUp' : 'ChevronDown'} size={18} color="#888" />
            </button>
            {isOpen && (
              <div className="px-4 pb-4 space-y-2">
                {cat?.risks?.map(risk => (
                  <div key={risk?.id} className={`flex items-start gap-3 p-3 rounded-lg ${risk?.flagged ? 'bg-red-500/5 border border-red-500/20' : 'bg-muted/20'}`}>
                    <div className={`w-5 h-5 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5 ${risk?.flagged ? 'bg-red-500/20' : 'bg-muted'}`}>
                      <Icon name={risk?.flagged ? 'AlertTriangle' : 'Check'} size={12} color={risk?.flagged ? '#FF4444' : '#888'} />
                    </div>
                    <div className="flex-1">
                      <p className={`text-sm ${risk?.flagged ? 'text-foreground' : 'text-muted-foreground'}`}>{risk?.label}</p>
                    </div>
                    <span className="px-2 py-0.5 rounded text-xs font-medium flex-shrink-0" style={{ background: severityConfig?.[risk?.severity]?.bg, color: severityConfig?.[risk?.severity]?.color }}>
                      {severityConfig?.[risk?.severity]?.label}
                    </span>
                  </div>
                ))}
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
};

export default RiskChecklist;
